import { render, staticRenderFns } from "./leftmenusuperadmin.vue?vue&type=template&id=84e06b2c&"
import script from "./leftmenusuperadmin.vue?vue&type=script&lang=js&"
export * from "./leftmenusuperadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports